import React from 'react';

const IconGoogleplay = () => {
  return (
    <div>
      <svg
        width="136"
        height="40"
        viewBox="0 0 136 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.496307" width="136" height="40" rx="8" fill="black" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.7544 17.3095C66.6682 17.3095 64.9772 18.8989 64.9772 21.0912C64.9772 23.2636 66.6792 24.8729 68.7544 24.8729C70.8406 24.8729 72.5316 23.2724 72.5316 21.0912C72.5316 18.8989 70.8406 17.3095 68.7544 17.3095ZM68.7544 23.3744C67.6131 23.3744 66.6307 22.4257 66.6307 21.0823C66.6307 19.7191 67.6153 18.7903 68.7544 18.7903C69.8957 18.7903 70.8781 19.7191 70.8781 21.0823C70.8803 22.4345 69.8957 23.3744 68.7544 23.3744ZM60.5134 17.3095C58.4272 17.3095 56.7362 18.8989 56.7362 21.0912C56.7362 23.2636 58.4382 24.8729 60.5134 24.8729C62.5996 24.8729 64.2906 23.2724 64.2906 21.0912C64.2906 18.8989 62.5974 17.3095 60.5134 17.3095ZM60.5134 23.3744C59.372 23.3744 58.3897 22.4257 58.3897 21.0823C58.3897 19.7191 59.3743 18.7903 60.5134 18.7903C61.6547 18.7903 62.6371 19.7191 62.6371 21.0823C62.6371 22.4345 61.6547 23.3744 60.5134 23.3744ZM50.7072 18.4644V20.0649H54.533C54.416 20.9626 54.1201 21.6254 53.6676 22.0799C53.1069 22.6429 52.2415 23.2547 50.716 23.2547C48.3649 23.2547 46.526 21.3483 46.526 18.9876C46.526 16.6268 48.3649 14.7204 50.716 14.7204C51.9854 14.7204 52.9104 15.2236 53.5969 15.8664L54.7272 14.7315C53.7736 13.8138 52.5042 13.1111 50.7248 13.1111C47.4995 13.1111 44.793 15.749 44.793 18.9787C44.793 22.2173 47.4973 24.8463 50.7248 24.8463C52.4666 24.8463 53.7736 24.2744 54.8067 23.1971C55.8597 22.1397 56.1931 20.6479 56.1931 19.4442C56.1931 19.0696 56.1644 18.7326 56.1048 18.4467H50.705C50.7072 18.4445 50.7072 18.4644 50.7072 18.4644ZM90.8172 19.7102C90.5015 18.8612 89.5478 17.3007 87.5919 17.3007C85.6536 17.3007 84.0421 18.8324 84.0421 21.0823C84.0421 23.2059 85.636 24.864 87.7795 24.864C89.5015 24.864 90.5037 23.8067 90.9166 23.186L89.6384 22.3259C89.2145 22.9577 88.6251 23.3722 87.7884 23.3722C86.9429 23.3722 86.3512 22.9865 85.9583 22.2262L90.9938 20.1314C90.9938 20.1336 90.8172 19.7102 90.8172 19.7102ZM85.6823 20.9737C85.6426 19.5129 86.8126 18.7703 87.6493 18.7703C88.3094 18.7703 88.8591 19.0962 89.0467 19.5706L85.6823 20.9737ZM81.5916 24.6379H83.2451V13.5278H81.5916V24.6379ZM78.8763 18.1496H78.8167C78.4436 17.7041 77.7349 17.3007 76.8298 17.3007C74.9511 17.3007 73.2204 18.961 73.2204 21.0934C73.2204 23.217 74.9423 24.8574 76.8298 24.8574C77.7239 24.8574 78.4436 24.4517 78.8167 23.9973H78.8763V24.5404C78.8763 25.9835 78.108 26.7615 76.8695 26.7615C75.8563 26.7615 75.2271 26.03 74.971 25.4182L73.5339 26.0212C73.9467 27.0187 75.0483 28.2534 76.8673 28.2534C78.8056 28.2534 80.4481 27.1073 80.4481 24.3121V17.5268H78.8851V18.1496C78.8873 18.1496 78.8763 18.1496 78.8763 18.1496ZM76.9777 23.3744C75.8364 23.3744 74.8827 22.4168 74.8827 21.0934C74.8827 19.759 75.8364 18.7925 76.9777 18.7925C78.108 18.7925 78.9844 19.7701 78.9844 21.0934C78.9955 22.4168 78.1102 23.3744 76.9777 23.3744ZM98.5593 13.5278H94.6055V24.6379H96.259V20.4306H98.5615C100.392 20.4306 102.191 19.0984 102.191 16.9837C102.191 14.8689 100.398 13.5278 98.5593 13.5278ZM98.6079 18.8789H96.2568V15.0662H98.6079C99.8463 15.0662 100.546 16.0925 100.546 16.9726C100.546 17.8437 99.8375 18.8789 98.6079 18.8789ZM108.818 17.2896C107.617 17.2896 106.379 17.8238 105.866 18.9876L107.332 19.5994C107.648 18.9876 108.226 18.7792 108.838 18.7792C109.694 18.7792 110.56 19.2935 110.58 20.2112V20.3287C110.284 20.1602 109.635 19.9031 108.858 19.9031C107.275 19.9031 105.67 20.772 105.67 22.4013C105.67 23.8931 106.968 24.8507 108.414 24.8507C109.524 24.8507 110.136 24.3475 110.518 23.7646H110.578V24.6246H112.171V20.3686C112.171 18.3868 110.706 17.2896 108.818 17.2896ZM108.611 23.3744C108.07 23.3744 107.312 23.1084 107.312 22.4257C107.312 21.5656 108.257 21.2397 109.063 21.2397C109.792 21.2397 110.136 21.3971 110.569 21.6144C110.449 22.6119 109.611 23.3655 108.611 23.3744ZM117.986 17.5268L116.088 22.3459H116.028L114.061 17.5268H112.282L115.233 24.2633L113.551 28.0073H115.273L119.814 17.5268H117.986ZM103.103 24.6379H104.756V13.5278H103.103V24.6379Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7329 8.69657C17.4768 8.97366 17.3289 9.39705 17.3289 9.95122V29.6067C17.3289 30.1609 17.4768 30.5843 17.7417 30.8503L17.8101 30.9101L28.7775 19.8976V19.6515L17.8013 8.63672L17.7329 8.69657Z"
          fill="url(#paint0_linear_175_621)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.4268 23.5794L28.7688 19.9063V19.6491L32.4268 15.9761L32.5063 16.0248L36.8332 18.4942C38.0717 19.1947 38.0717 20.3518 36.8332 21.0612L32.5063 23.5306L32.4268 23.5794Z"
          fill="url(#paint1_linear_175_621)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.5063 23.5307L28.7688 19.7778L17.7329 30.8591C18.1369 31.2936 18.8147 31.3424 19.5719 30.919L32.5063 23.5307Z"
          fill="url(#paint2_linear_175_621)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.5063 16.025L19.5719 8.64781C18.8147 8.21334 18.1347 8.27319 17.7329 8.70766L28.7688 19.7779L32.5063 16.025Z"
          fill="url(#paint3_linear_175_621)"
        />
        <path
          opacity="0.2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.4267 23.4509L19.5807 30.7793C18.8632 31.1939 18.223 31.1651 17.8102 30.7882L17.7417 30.8569L17.8102 30.9168C18.223 31.2914 18.8632 31.3224 19.5807 30.9079L32.515 23.5307L32.4267 23.4509Z"
          fill="black"
        />
        <path
          opacity="0.12"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.8325 20.9326L32.4157 23.4504L32.4951 23.5302L36.8215 21.0611C37.4417 20.7065 37.7463 20.2411 37.7463 19.7778C37.7088 20.2034 37.3932 20.6068 36.8325 20.9326Z"
          fill="black"
        />
        <path
          opacity="0.25"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5718 8.77635L36.8331 18.6229C37.3938 18.9399 37.7095 19.3545 37.7581 19.7778C37.7581 19.3145 37.4534 18.849 36.8331 18.4944L19.5718 8.64778C18.3333 7.93622 17.3289 8.53029 17.3289 9.9512V10.0798C17.3289 8.65665 18.3333 8.07365 19.5718 8.77635Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_175_621"
            x1="27.7938"
            y1="9.73916"
            x2="10.2164"
            y2="14.4035"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00A0FF" />
            <stop offset="0.00657" stopColor="#00A1FF" />
            <stop offset="0.2601" stopColor="#00BEFF" />
            <stop offset="0.5122" stopColor="#00D2FF" />
            <stop offset="0.7604" stopColor="#00DFFF" />
            <stop offset="1" stopColor="#00E3FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_175_621"
            x1="38.4483"
            y1="19.7778"
            x2="17.028"
            y2="19.7778"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFE000" />
            <stop offset="0.4087" stopColor="#FFBD00" />
            <stop offset="0.7754" stopColor="#FFA500" />
            <stop offset="1" stopColor="#FF9C00" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_175_621"
            x1="30.474"
            y1="21.8199"
            x2="16.2847"
            y2="45.6037"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF3A44" />
            <stop offset="1" stopColor="#C31162" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_175_621"
            x1="14.954"
            y1="2.15885"
            x2="21.2844"
            y2="12.7811"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#32A071" />
            <stop offset="0.0685" stopColor="#2DA771" />
            <stop offset="0.4762" stopColor="#15CF74" />
            <stop offset="0.8009" stopColor="#06E775" />
            <stop offset="1" stopColor="#00F076" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default IconGoogleplay;
